import { Component, Input } from '@angular/core';
import { ICollapse } from '@core/interfaces/ilookup';

@Component({
  selector: 'prism-collapse',
  templateUrl: './collapse.component.html',
  styleUrl: './collapse.component.scss'
})
export class CollapseComponent  {
 @Input() panel!: ICollapse;
  isOpen = false;
  contentId = '';
  headerId = '';

  ngOnInit(): void {
    this.contentId = `collapse-content-${this.panel.id}`;
    this.headerId = `collapse-header-${this.panel.id}`;
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggle();
    }
  }
}
